module.exports = __webpack_public_path__ + "img/SMT_21_Ms_Ivy_Lok.bb58d3ca.jpg";